"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initializeLogger;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Initializes logger function via window.onerror, respecting the old handler if any
 * @param {String} url
 */
function initializeLogger(url) {
  var oldHandler = window.onerror;

  window.onerror = function (message, source, lineno, colno, error) {
    sendLog(url, message);

    if (oldHandler) {
      return oldHandler(message, source, lineno, colno, error);
    } else {
      // fire default error handler
      return false;
    }
  };
}
/**
 * Sends log data
 * @param {String} url
 * @param {String|Event} message - error message
 */


function sendLog(url, message) {
  _axios["default"].post(url, {
    message: message,
    userAgent: navigator.userAgent,
    page: window.location.href
  });
}